import axios from "axios";

export default {
    Employee: {
        Balance: {
            async Table(year, eid) {
                const response = await axios.post(`/api/hroperations/employee/balance/table/${year}/${eid}`);
                return response;
            },
            async Update(data) {
                // data: { Id, Amount, DueDate, Description, ProjectType }
                // ProjectType değeri: "Kart" | "Banka 1" | "Banka 2" — backend enum Display Name ile eşleşir.
                const response = await axios.post(`/api/employeebalance/update`, data);
                return response;
            },
        },
        async Table(data) {
            const response = await axios.post("/api/hroperations/employee/table", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/hroperations/employee/delete/${id}`);
            return response;
        },
        async TableExcel(data) {
            const response = await axios.post("/api/hroperations/employee/table/excel", data);
            return response;
        },
        async CreateOrUpdate(data) {
            const response = await axios.post("/api/hroperations/employee/createorupdate", data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        Candidate: {
            async CreateOrUpdate(data) {
                const response = await axios.post("/api/hroperations/candidate-employee/createorupdate", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async List(includeConverted = false) {
                const response = await axios.get(`/api/hroperations/candidate-employee/list`, {
                    params: { includeConverted },
                });
                return response;
            },
            async Get(id) {
                const response = await axios.get(`/api/hroperations/candidate-employee/${id}`);
                return response;
            },
            async Delete(id) {
                const response = await axios.delete(`/api/hroperations/candidate-employee/${id}`);
                return response;
            },
            async Convert(id) {
                const response = await axios.post(`/api/hroperations/candidate-employee/${id}/convert`);
                return response;
            },
        },
        async UpdateEkHakedisInfo(data) {
            const response = await axios.post("/api/hroperations/employee/updateekhakedisinfo", data);
            return response;
        },
        async GetAllowances(employeeId) {
            const response = await axios.get(`/api/hroperations/employee/allowances/${employeeId}`);
            return response;
        },
        async SaveAllowance(data) {
            const response = await axios.post("/api/hroperations/employee/allowance/save", data);
            return response;
        },
        async DeleteAllowance(id) {
            const response = await axios.post(`/api/hroperations/employee/allowance/delete/${id}`);
            return response;
        },
        async GetSalarySupports(employeeId) {
            const response = await axios.get(`/api/hroperations/employee/salarysupports/${employeeId}`);
            return response;
        },
        async SaveSalarySupport(data) {
            const response = await axios.post("/api/hroperations/employee/salarysupport/save", data);
            return response;
        },
        async DeleteSalarySupport(id) {
            const response = await axios.post(`/api/hroperations/employee/salarysupport/delete/${id}`);
            return response;
        },
        async UpdateArabuluculukInfo(data) {
            const response = await axios.post("/api/hroperations/employee/updatearabuluculuk", data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        async Get(data) {
            const response = await axios.get(`/api/hroperations/employee/get/${data}`);
            return response;
        },
        async GetDigitalNumbers(data) {
            const response = await axios.get(`/api/hroperations/driverlicense/getdigitalnumbers/${data}`);
            return response;
        },
        async List(onlyActive = false) {
            const response = await axios.get(`/api/hroperations/employee/list/select`, {
                params: { onlyActive },
            });
            return response;
        },
        async NotMatchedTable(data) {
            const response = await axios.post(`/api/hroperations/employee/getemployeesnotmatchwithtachograph`, data);
            return response;
        },
        async NotAssignedTable(data) {
            const response = await axios.post(`/api/hroperations/employee/notassigned/table`, data);
            return response;
        },
        async NotAssignedExcel() {
            const response = await axios.get(`/api/hroperations/employee/notassigned/excel`, { responseType: "blob" });
            return response;
        },
        async UpdateDigitalLicenseNumber(data) {
            const response = await axios.post(`/api/hroperations/employee/updatedigitallicensenumber`, data);
            return response;
        },
        async GetFiles(data) {
            const response = await axios.get(`/api/hroperations/employee/getfiles/${data}`);
            return response;
        },
        async Search(data) {
            const response = await axios.get(`/api/hroperations/get/employees/search/${data}`);
            return response;
        },
        async SearchByDate(data, date) {
            const response = await axios.get(`/api/hroperations/get/employees/searchwithdate/${data}/${date}`);
            return response;
        },
        async SearchIncident(data, incidentDate) {
            const response = await axios.get(`/api/hroperations/get/employees/searchwithincidentdate/${data}/${incidentDate}`);
            return response;
        },
        async SearchDriver(data) {
            const response = await axios.get(`/api/hroperations/get/drivers/search/${data}`);
            return response;
        },
        async SearchActiveDriver(data) {
            const response = await axios.get(`/api/hroperations/get/activedrivers/search/${data}`);
            return response;
        },
        async GetApproversOfExit(data) {
            const response = await axios.get(`/api/hroperations/get/exitapprovers/search/${data}`);
            return response;
        },
        async SearchByBranch(data, branchId) {
            const response = await axios.get(`/api/hroperations/get/employees/search/${branchId}/${data}`);
            return response;
        },
        async createSalary(request) {
            const response = await axios.get("/api/employeebalance/salary/create", { params: request });
            return response;
        },
        File: {
            async Table(data) {
                const response = await axios.post("/api/hroperations/employee/file/table", data);
                return response;
            },
            async Upload(data) {
                const response = await axios.post("/api/hroperations/employee/file/upload", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/hroperations/employee/file/delete/${data}`);
                return response;
            },
        },
        RegistryFile: {
            async List(data, employee) {
                const response = await axios.get(`/api/hroperations/employee/getregistrydocumentsnamelist/${employee}/${data}`);
                return response;
            },
            async ExternalList(data, employee) {
                const response = await axios.get(`/api/hroperations/registrydocument/external/list/${employee}/${data}`);
                return response;
            },
            async Generate(data, index, type) {
                const response = await axios.get(`/api/hroperations/employee/getgeneratedregistrydocument/${data}/${index}/${type}`);
                return response;
            },
            async Upload(data) {
                const response = await axios.post("/api/hroperations/employee/registrydocument/upload", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async GetProcess(employeeType, data, fileName) {
                const response = await axios.post(`/api/hroperations/employee/registrydocument/getprocesses/${employeeType}/${fileName}/${data}`);
                return response;
            },
            async CreateOrUpdateValue(update, data) {
                const response = await axios.post(update ? `/api/hroperations/employee/registrydocument/updatevalue` : `/api/hroperations/employee/registrydocument/createvalue`, data);
                return response;
            },
            async DeleteValue(data) {
                const response = await axios.post(`/api/hroperations/employee/registrydocument/deletevalue/${data}`);
                return response;
            },
            async GetAll() {
                const response = await axios.get(`/api/hroperations/employee/registrydocument/getall`);
                return response;
            },
            async GetValueType() {
                const response = await axios.get(`/api/hroperations/employee/registrydocument/getvaluetypes`);
                return response;
            },
            async GetValues(data) {
                const response = await axios.get(`/api/hroperations/employee/registrydocument/getvalues/${data}`);
                return response;
            },
        },
        EmployeeSicilBelge: {
            async List(employeeId) {
                const response = await axios.get(`/api/hroperations/sicilbelgeleri/list/${employeeId}`);
                return response;
            },
            async GetTypesByCollarStatus(collarStatus) {
                const response = await axios.get(`/api/hroperations/sicilbelgeleri/types/${collarStatus}`);
                return response;
            },
            async Upload(data) {
                const response = await axios.post("/api/hroperations/sicilbelgeleri/create", data, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                return response;
            },
            async Delete(id) {
                const response = await axios.post(`/api/hroperations/sicilbelgeleri/delete/${id}`);
                return response;
            },
        },
        SGK: {
            async GetNotices(data) {
                const response = await axios.get(`/api/hroperations/employee/sgk/notices/get/${data}`);
                return response;
            },
            async Delete(id) {
                const response = await axios.get(`/api/hroperations/employee/sgk/delete/${id}`);
                return response;
            },
            async DeleteExit(id) {
                const response = await axios.get(`/api/hroperations/employee/sgk/delete/exit/${id}`);
                return response;
            },
            async EntryNotice(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/isegiriskayit", data);
                return response;
            },
            async ExitNotice(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/istencikiskayit", data);
                return response;
            },
            async JobExitTemporary(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/istencikiskayittemporary", data);
                return response;
            },
            async Type(type) {
                const response = await axios.get(`/api/hroperations/employee/sgk/getparameters/${type}`);
                return response;
            },
            async TypeWithJobExitCause(type,jecid) {
                const response = await axios.get(`/api/hroperations/employee/sgk/getparameters/${type}/${jecid}`);
                return response;
            },
            async StepThree(data, jecc, nu) {
                const response = await axios.get(`/api/hroperations/employee/sgk/exitstepthree/${data}/${jecc}/${nu}`);
                return response;
            },
            async CalculateUseOfNotice(jobStartDate, notifyDate) {
                const response = await axios.get(`/api/hroperations/employee/sgk/calculateuseofnotice/${jobStartDate}/${notifyDate}`);
                return response;
            },
            async CalculateUseOfNoticeJobExitDate(data, notifyDate) {
                const response = await axios.post(`/api/hroperations/employee/sgk/calculateuseofnoticejobexitdate/${notifyDate}`, data);
                return response;
            },
            async GetProcessPaymentTable(data) {
                const response = await axios.get(`/api/hroperations/employee/sgk/progresspaymenttable/${data}`);
                return response;
            },
            async GetMediation(data) {
                const response = await axios.get(`/api/hroperations/employee/sgk/mediation/get/${data}`);
                return response;
            },
            async GetPDF(data) {
                const response = await axios.get(`/api/hroperations/employee/sgk/getpdf/${data}`);
                return response;
            },
            async CreateOrUpdateMeaditon(update, data) {
                const response = await axios.post(update ? `/api/hroperations/employee/sgk/mediation/update` : `/api/hroperations/employee/sgk/mediation/create`, data);
                return response;
            },
            async NakilKayit(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/nakilkayit", data);
                return response;
            },
            async Update(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/notice/update", data);
                return response;
            },
            async AbortEntry(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/abortentry", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async UploadEntryDoc(data) {
                const response = await axios.post("/api/hroperations/employee/sgk/uploadentrydoc", data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
        },
        async LucaMatch(data) {
            const response = await axios.post(`/api/hroperations/employee/lucamatch`, data);
            return response;
        },
        async LucaImport(data) {
            const response = await axios.post(`/api/hroperations/employee/lucaimport`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
    },
    Excuse: {
        async GetAll() {
            const response = await axios.get(`/api/hroperations/excuse/getall`);
            return response;
        },
        async GetAllTable(data) {
            const response = await axios.post(`/api/hroperations/excuse/getall/table`, data);
            return response;
        },
        async GetAllHourlyTable(data) {
            const response = await axios.post(`/api/hroperations/excuse/gethourly/table`, data);
            return response;
        },
        async CreateOrUpdate(data) {
            const response = await axios.post(`/api/hroperations/excuse/createorupdate`, data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        async End(data, date) {
            const response = await axios.get(`/api/hroperations/excuse/end/${data}/${date}`);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/excuse/delete/${data}`);
            return response;
        },
        async GetDailyCheck(date) {
            const response = await axios.post(`/api/hroperations/excuse/getdailycheck/${date}`);
            return response;
        },
        async GetDocumentWaiting(data) {
            const response = await axios.post(`/api/hroperations/excuse/getdocumentwaiting`, data);
            return response;
        },
        async RemainingAnnualHoliday(data) {
            const response = await axios.post(`/api/hroperations/employee/remainingannualholiday`, data);
            return response;
        },
        // Madde 23: Yıllık izin hakedişinde baz alınacak tarih.
        // Kayıt yoksa hakediş SGK işe giriş tarihinden işler.
        async GetAnnualLeaveBaseDate(employeeId) {
            const response = await axios.get(`/api/hroperations/employee/annualleavebasedate/${employeeId}`);
            return response;
        },
        async SaveAnnualLeaveBaseDate(data) {
            const response = await axios.post(`/api/hroperations/employee/annualleavebasedate/save`, data);
            return response;
        },
        async DeleteAnnualLeaveBaseDate(employeeId) {
            const response = await axios.post(`/api/hroperations/employee/annualleavebasedate/delete/${employeeId}`);
            return response;
        },
        async PublicHolidayTable(data) {
            const response = await axios.post(`/api/hroperations/excuse/publicholiday/table`, data);
            return response;
        },
        async PublicHolidayUse(id) {
            const response = await axios.post(`/api/hroperations/excuse/publicholiday/use/${id}`);
            return response;
        },
    },
    ExcuseType: {
        async Table(data) {
            const response = await axios.post("/api/hroperations/employeeexcusetype/table", data);
            return response;
        },
        async List() {
            const response = await axios.get(`/api/hroperations/employeeexcusetype/list/select`);
            return response;
        },
        async CreateOrUpdate(data) {
            const response = await axios.post(`/api/hroperations/employeeexcusetype/createorupdate`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/employeeexcusetype/delete/${data}`);
            return response;
        },
    },
    Tachograph: {
        async MonthlyDrivingTime(month, year, displayMode = "utc") {
            const response = await axios.get(`/api/tachograph/monthlydrivingtime/${month}/${year}`, {
                params: { displayMode },
            });
            return response;
        },
        async MonthlyDrivingWithWorkingTime(month, year, displayMode = "utc") {
            const response = await axios.get(`/api/tachograph/monthlydrivingwithworkingtime/${month}/${year}`, {
                params: { displayMode },
            });
            return response;
        },
        async UploadFile(data) {
            const response = await axios.post(`/api/tachograph/file/upload/driver`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
        async VehicleUploadFile(data) {
            const response = await axios.post(`/api/tachograph/file/upload/vehicle`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
        async ExcelExport(month, year) {
            const response = await axios.get(`/api/tachograph/excel/${month}/${year}`, { responseType: "blob" });
            return response;
        },
        async WrongData(data) {
            const response = await axios.post(`/api/tachograph/table/wrongdata`, data);
            return response;
        },
        async OutOfInventoryPlate(data) {
            const response = await axios.post(`/api/tachograph/table/outofinventoryplate`, data);
            return response;
        },
        async VehicleDriverCardMovement(data) {
            const response = await axios.post(`/api/tachograph/table/vehicledrivercardmovement`, data);
            return response;
        },
        async VehicleMonthlyDrivingTime(month, year) {
            const response = await axios.get(`/api/tachograph/vehicle/monthlydrivingtime/${month}/${year}`);
            return response;
        },
        async ExcelVehicleExport(month, year) {
            const response = await axios.get(`/api/tachograph/excel/vehicle/${month}/${year}`, { responseType: "blob" });
            return response;
        },
        async TachographJSON(id, displayMode = "utc", displayDate = null) {
            const response = await axios.get(`/api/tachograph/get/tachographjson/${id}`, {
                params: { displayMode, displayDate },
            });
            return response;
        },
        async TachographJSONThreeDay(id, date, displayMode = "utc") {
            const response = await axios.get(`/api/tachograph/get/tachographthreedayjson/${id}/${date}`, {
                params: { displayMode },
            });
            return response;
        },
        async UploadReport(data) {
            const response = await axios.post(`/api/tachograph/get/tachographuploadreport`, data);
            return response;
        },
        async SeyirDriverFileDownloadReport(data) {
            const response = await axios.post(`/api/seyir/get/driverfiledownloadreport`, data);
            return response;
        },
        async SeyirDriverFileDownload(logId) {
            const response = await axios.get(`/api/seyir/download/driverfile/${logId}`, { responseType: "blob" });
            return response;
        },
        async SeyirTriggerDriverFileDownload(employeeId) {
            const response = await axios.post(`/api/seyir/driverfile/trigger`, { EmployeeId: employeeId });
            return response;
        },
        async SeyirDriverFileDownloadTodayFailures() {
            const response = await axios.get(`/api/seyir/driverfile/todayfailures`);
            return response;
        },
        async SeyirDriverFileDownloadDayDetails(employeeId, date) {
            const response = await axios.get(`/api/seyir/driverfile/daydetails`, { params: { employeeId, date } });
            return response;
        },
        async SeyirDriverFileDownloadReportExcel(data) {
            const response = await axios.post(`/api/seyir/driverfiledownloadreport/export`, data, { responseType: "blob" });
            return response;
        },
        async CreateOrUpdateManual(update, data) {
            const response = await axios.post(update ? `/api/tachograph/updatemanualtachographdata` : `/api/tachograph/createmanualtachographdata`, data);
            return response;
        },
        async GetManualTachograph(id) {
            const response = await axios.get(`/api/tachograph/get/manualtachographdata/${id}`);
            return response;
        },
    },
    Score: {
        async List(data) {
            const response = await axios.get(`/api/hroperations/employee/score/getdailycheck/${data}`);
            return response;
        },
        async ListByDate(data) {
            const response = await axios.get(`/api/hroperations/employee/score/getdailychecknew/${data}`);
            return response;
        },
        async WorkingType() {
            const response = await axios.get(`/api/hroperations/employee/workingtype/get`);
            return response;
        },
        async WorkingTypeExcuseFilter(excuses) {
            const response = await axios.get(`/api/hroperations/employee/workingtype/get/${excuses}`);
            return response;
        },
        async EksikGunByKykm(data) {
            const response = await axios.get(`/api/hroperations/employee/eksikgun/getbykykm/${data}`);
            return response;
        },
        async ResetPresave(data) {
            const response = await axios.post(`/api/hroperations/employee/score/resetpresave`, data);
            return response;
        },
        async ChangeLockStatus(data) {
            const response = await axios.post(`/api/hroperations/employee/score/changelockstatus`, data);
            return response;
        },
        async LockStatusTable(data) {
            const response = await axios.post(`/api/hroperations/employee/score/lockstatus/table`, data);
            return response;
        },
        async Check(data) {
            const response = await axios.post(`/api/hroperations/employee/score/createdailycheck`, data);
            return response;
        },
        async AllMonthly(data) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getallmonthly`, data);
            return response;
        },
        async AllMonthlyNew(data) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getallmonthlynew`, data);
            return response;
        },
        async AllMonthlyEmployee(month, year, date, id) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getallmonthly/${month}/${year}/${date}/${id}`);
            return response;
        },
        async SavedMonthlyO(month, year) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getsavedmonthly/${month}/${year}`);
            return response;
        },
        async SavedMonthly(data) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getsavedmonthly`, data);
            return response;
        },
        async SavedMonthlyByQueryParam(month, year, queryParam) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getsavedmonthlybyqueryparam/${month}/${year}/${queryParam}`);
            return response;
        },
        async SavedMonthlyWithBranch(branch, month, year) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getsavedmonthlybybranch/${branch}/${month}/${year}`);
            return response;
        },
        async SavedMonthlyWithEmployee(month, year, eId) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/getsavedmonthlybyemployee/${month}/${year}/${eId}`);
            return response;
        },
        async NotDriverSavedMonthlyO(month, year) {
            const response = await axios.post(`/api/hroperations/employee/score/getsavedmonthly/${month}/${year}`);
            return response;
        },
        async NotDriverSavedMonthly(data) {
            const response = await axios.post(`/api/hroperations/employee/score/getsavedmonthly`, data);
            return response;
        },
        async NotDriverSavedMonthlyWithBranch(branch, month, year) {
            const response = await axios.post(`/api/hroperations/employee/score/getsavedmonthlybybranch/${branch}/${month}/${year}`);
            return response;
        },
        async NotDriverSavedMonthlyWithEmployee(year, month, eId) {
            const response = await axios.post(`/api/hroperations/employee/score/getsavedmonthlybyemployee/${month}/${year}/${eId}`);
            return response;
        },
        async NetsisFinal(month, year) {
            const response = await axios.get(`/api/hroperations/driver/score/netsisfinal/${month}/${year}`);
            return response;
        },
        async NetsisPuantaj(data) {
            const response = await axios.post(`/api/hroperations/employee/netsis/puantaj`, data);
            return response;
        },
        async NetsisPuantajExcel(data) {
            const response = await axios.post(`/api/hroperations/employee/netsis/puantaj/excel`, data);
            return response;
        },
        async NotDriverNetsisFinal(month, year) {
            const response = await axios.get(`/api/hroperations/score/netsisfinal/${month}/${year}`);
            return response;
        },
        async NotDriverNetsisFinalWithBranch(branch, month, year) {
            const response = await axios.get(`/api/hroperations/score/netsisfinal/${branch}/${month}/${year}`);
            return response;
        },
        async Create(data) {
            const response = await axios.post(`/api/hroperations/employee/score/create`, data);
            return response;
        },
        async CreateNew(data) {
            const response = await axios.post(`/api/hroperations/employee/score/createnew`, data);
            return response;
        },
        async CreateNew(data) {
            const response = await axios.post(`/api/hroperations/employee/score/createnew`, data);
            return response;
        },
        async DeleteSaved(data) {
            const response = await axios.post(`/api/hroperations/employee/score/deletesaved`, data);
            return response;
        },
        async CheckInsert(data, id, bool) {
            const response = await axios.get(bool ? `/api/hroperations/employee/score/checkinsert/idari/${data}/${id}` : `/api/hroperations/employee/score/checkinsert/${data}/${id}`);
            return response;
        },

        async NetsisInsert(data) {
            const response = await axios.post(`/api/hroperations/employee/score/netsis/insert`, data);
            return response;
        },
        async NetsisInsertNew(data) {
            const response = await axios.post(`/api/hroperations/employee/score/netsis/insertnew`, data);
            return response;
        },
        async NetsisInsertNew(data) {
            const response = await axios.post(`/api/hroperations/employee/score/netsis/insertnew`, data);
            return response;
        },
        async NetsisInsertEmployee(month, year, id) {
            const response = await axios.get(`/api/hroperations/employee/score/netsis/insert/${month}/${year}/${id}`);
            return response;
        },
        async GetDailyScoreMonthly(data) {
            const response = await axios.post(`/api/hroperations/employee/score/getdailyscoremonthly`, data);
            return response;
        },
        async CreateOrUpdateDailyScore(data) {
            const response = await axios.post(`/api/hroperations/employee/score/daily/createorupdate`, data);
            return response;
        },
        async PreSave(data) {
            const response = await axios.post(`/api/hroperations/employee/score/presave`, data);
            return response;
        },
        async Excel(data) {
            const response = await axios.post(`/api/hroperations/employee/score/excel`, data);
            return response;
        },
        async ExcelDriver(data) {
            const response = await axios.post(`/api/hroperations/employee/driver/score/excel`, data);
            return response;
        },
        async TestPuantaj(data) {
            const response = await axios.post(`/api/hroperations/employee/netsis/testpuantaj`, data);
            return response;
        },
        async InsertAdditional(data) {
            const response = await axios.post(`/api/hroperations/employee/salaryeffect/bypassnetsispuantajpresave`, data);
            return response;
        },
    },
    NotDriverScore: {
        async AllMonthly(data) {
            const response = await axios.post(`/api/hroperations/employee/score/getallmonthly`, data);
            return response;
        },
        async AllMonthlyNew(data) {
            const response = await axios.post(`/api/hroperations/employee/score/getallmonthlynew`, data);
            return response;
        },
    },
    PersonalProtectiveEquipment: {
        async Debit(data) {
            const response = await axios.post(`/api/hroperations/employee/ppe/debit`, data);
            return response;
        },
    },
    SalaryEffect: {
        async KYKMTable(data) {
            const response = await axios.post("/api/hroperations/kykm/assignment/table", data);
            return response;
        },
        async KYKMTableDelete(id) {
            const response = await axios.post(`/api/hroperations/kykm/delete/${id}`);
            return response;
        },
        async Table(data, id) {
            const response = await axios.post(`/api/hroperations/salaryeffect/table/${id}`, data);
            return response;
        },
        async Create(data) {
            const response = await axios.post("/api/hroperations/salaryeffect/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/salaryeffect/delete/${data}`);
            return response;
        },
        async CalculateEarning(data) {
            const response = await axios.post(`/api/hroperations/employee/salaryeffect/calculateearning`, data);
            return response;
        },
        Assign: {
            async Common(data) {
                const response = await axios.post(`/api/hroperations/kykm/assign`, data);
                return response;
            },
            // type: ödeme dosyası türü (2 = Maaş Avansı, 5 = Yıllık İzin Avansı, 1 = Maaş).
            // Verildiğinde liste yalnızca o türdeki dosyaları döner; verilmezse eski davranış korunur.
            // Tür gönderilmediğinde İcra dosyaları da listeye düşüyor ve atama yanlış dosyaya yapılabiliyordu.
            async GroupKeyList(bool = true, type = null) {
                const response = await axios.get(`/api/hroperations/kykm/sterling/groupkey/list/${bool}`, {
                    params: type != null ? { type } : {}
                });
                return response;
            },
            async GroupKeyCreate(date, accountId, type) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/groupkey/create/${date}/${accountId}/${type}`);
                return response;
            },
            async GroupKeyTable(data) {
                const response = await axios.post(`/api/hroperations/sterling/uploadstatus/table`, data);
                return response;
            },
            async GroupKeyRSalaryTable(data) {
                const response = await axios.post(`/api/hroperations/rsalary/sterling/uploadstatus/table`, data);
                return response;
            },
            async GroupKeySend(id) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/send/${id}`);
                return response;
            },
            async GroupKeyGenerate(id) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/generate/${id}`);
                return response;
            },
            async GroupKeyAbort(id) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/abort/${id}`);
                return response;
            },
            async GroupKeyFinanceAbort(id) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/financeabort/${id}`);
                return response;
            },
            async GroupKeyDelete(id) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/delete/${id}`);
                return response;
            },
            // async GroupKeyListBySterling(data){
            //     const response = await axios.post(`/api/hroperations/kykm/assignment/listbysterling`,data)
            //     return response
            // },
            // async GroupKeyRSalaryListBySterling(data){
            //     const response = await axios.post(`/api/hroperations/rsalary/assignment/listbysterling`,data)
            //     return response
            // },
            async GroupKeyListBySterling(data) {
                const response = await axios.post(`/api/hroperations/sterling/listpayments`, data);
                return response;
            },
            async GroupKeyListDelete(data) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/amount/delete`, data);
                return response;
            },
            async GroupKeyListRSalaryDelete(data) {
                const response = await axios.post(`/api/hroperations/rsalary/sterling/amount/delete`, data);
                return response;
            },
            async GroupKeyListChangeAmount(data) {
                const response = await axios.post(`/api/hroperations/sterling/amount/update`, data);
                return response;
            },
            // async GroupKeyListRSalaryChangeAmount(data){
            //     const response = await axios.post(`/api/hroperations/rsalary/sterling/amount/update`,data)
            //     return response
            // },
            async GroupKeyUpdatePaymentDate(data) {
                const response = await axios.post(`/api/hroperations/kykm/sterling/update/paymentdate`, data);
                return response;
            },
            async GroupKeyCheckStatus() {
                const response = await axios.post(`/api/hroperations/kykm/sterling/checkstatus`);
                return response;
            },
            async RSalarySterlingAssing(data) {
                const response = await axios.post(`/api/hroperations/rsalary/sterling/assign`, data);
                return response;
            },
            // Arabuluculuk ödemelerini Sterling gönderim grubuna atar (Type = Arabuluculuk).
            async MediationSterlingAssign(data) {
                const response = await axios.post(`/api/hroperations/mediation/sterling/assign`, data);
                return response;
            },
            async Delete(data, type) {
                const response = await axios.post(`/api/hroperations/kykm/assignment/delete/${data}`);
                return response;
            },
            Department: {
                async Table(data) {
                    const response = await axios.post(`/api/hroperations/kykm/departmentassignment/table`, data);
                    return response;
                },
                async Delete(data) {
                    const response = await axios.post(`/api/hroperations/salaryeffect/type/departmentassignment/delete/${data}`);
                    return response;
                },
            },
            Employee: {
                async Table(data, id) {
                    const response = await axios.post(`/api/hroperations/salaryeffect/type/employeeassignment/table`, data);
                    return response;
                },
                async Delete(data) {
                    const response = await axios.post(`/api/hroperations/salaryeffect/type/employeeassignment/delete/${data}`);
                    return response;
                },
            },
            Rule: {
                async Table(data) {
                    const response = await axios.post(`/api/hroperations/kykm/assignmentrule/table`, data);
                    return response;
                },
                async CreateOrUpdate(update, data) {
                    const response = await axios.post(update ? `/api/hroperations/kykm/assignmentrule/update` : `/api/hroperations/kykm/assignmentrule/create`, data);
                    return response;
                },
                async Delete(data) {
                    const response = await axios.post(`/api/hroperations/kykm/assignmentrule/delete/${data}`);
                    return response;
                },
                async List() {
                    const response = await axios.post(`/api/hroperations/kykm/assignmentrule/list`);
                    return response;
                },
                async LimitTypeList() {
                    const response = await axios.get(`/api/hroperations/kykm/assignmentrule/limittype/list`);
                    return response;
                },
            },
        },
    },
    GarageSalary: {
        async Table(data) {
            const response = await axios.post("/api/hroperations/vehicleinventorygarage/salary/table", data);
            return response;
        },
        async List() {
            const response = await axios.get(`/api/hroperations/vehicleinventorygarage/salary/list/select`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/hroperations/vehicleinventorygarage/salary/update` : `/api/hroperations/vehicleinventorygarage/salary/set`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/salary/delete/${data}`);
            return response;
        },
    },
    VehicleInventoryGarage: {
        async Table(data, id) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/employee/table/${id}`, data);
            return response;
        },
        async List() {
            const response = await axios.get(`/api/hroperations/vehicleinventorygarage/employee/list/select`);
            return response;
        },
        async Assign(data) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/employee/assign`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/employee/delete/${data}`);
            return response;
        },
    },
    TrafficFine: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employeetrafficfine/table`, data);
            return response;
        },
        async Get(data) {},
        async List() {
            const response = await axios.get(`/api/hroperations/employeetrafficfine/list/select`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/hroperations/employeetrafficfine/update` : `/api/hroperations/employeetrafficfine/create`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
        async Get(id) {
            const response = await axios.get(`/api/employeetrafficfine/employeetrafficfine/get/${id}`);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/employeetrafficfine/delete/${data}`);
            return response;
        },
        async Deactivate(data) {
            const response = await axios.post(`/api/employeetrafficfine/employeetrafficfine/deactivate`, data);
            return response;
        },
        async GetLocationData(data) {
            const response = await axios.post("/api/trafficfine/getlocationdata", data);
            return response;
        },
        async GetApprovers(trafficFineId) {
            const response = await axios.get(`/api/employeetrafficfine/getapprovers/${trafficFineId}`);
            return response;
        },
        async Performance(data) {
            const response = await axios.post(`/api/employeetrafficfine/report/performance`,data);
            return response;
        },
        async Official(data) {
            const response = await axios.post(`/api/employeetrafficfine/report/official`,data);
            return response;
        },
        Payment: {
            async Table(data) {
                const response = await axios.post(`/api/hroperations/employeetrafficfine/payment/table`, data);
                return response;
            },
            async Create(data) {
                const response = await axios.post(`/api/hroperations/employeetrafficfine/payment/create`, data, { headers: { "Content-Type": "multipart/form-data" } });
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/hroperations/employeetrafficfine/payment/delete/${data}`);
                return response;
            },
            async Calculate(employeeTrafficFineId, paymentDate) {
                const response = await axios.get(`/api/employeetrafficfine/payment/calculate/${employeeTrafficFineId}/${paymentDate}`);
                return response;
            },
            async BulkCreate(data) {
                const response = await axios.post(`/api/hroperations/employeetrafficfine/payment/bulk-create`, data);
                return response;
            },
        },
        ApprovalConfiguration: {
            async Table(data) {
                const response = await axios.post("/api/employeetrafficfine/approvalconfiguration/table", data);
                return response;
            },
            async CreateOrUpdate(editing, data) {
                const url = editing ? "/api/employeetrafficfine/approvalconfiguration/update" : "/api/employeetrafficfine/approvalconfiguration/create";
                const response = await axios.post(url, data);
                return response;
            },
            async Delete(id) {
                const response = await axios.post(`/api/employeetrafficfine/approvalconfiguration/delete/${id}`);
                return response;
            },
        },

        async myApprovals() {
            const response = await axios.get("/api/employeetrafficfine/myapprovals");
            return response;
        },

        async GetTrafficFineDetail(id) {
            const response = await axios.get(`/api/trafficfine/get/${id}`);
            return response;
        },

        async GetTaskWithOTT(q) {
            const response = await axios.get(`/api/employeetrafficfine/getemployeetrafficfinewithott/${q.trim()}`);
            return response;
        },
        async ChangeApprovalStatusWithOTT(data) {
            const response = await axios.post("/api/employeetrafficfine/changeapprovalstatuswithott", data);
            return response;
        },
        async ChangeApprovalStatus(id,approve,description) {
            const response = await axios.post(`/api/employeetrafficfine/changeapprovalstatus/${id}/${approve}/${description}`);
            return response;
        },
    },
    Levy: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employeelevy/table`, data);
            return response;
        },
        async List() {
            const response = await axios.get(`/api/hroperations/employeelevy/list/select`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/hroperations/employeelevy/update` : `/api/hroperations/employeelevy/create`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/employeelevy/delete/${data}`);
            return response;
        },
        async GetByEmployee(data) {
            const response = await axios.post(`/api/hroperations/employeelevy/getbyemployee`, data);
            return response;
        },
        async CalculateOrder(data) {
            const response = await axios.post(`/api/hroperations/employee/levy/calculateorder`, data);
            return response;
        },
        async Deactivate(data) {
            const response = await axios.get(`/api/hroperations/employeelevy/deactivate/${data}`);
            return response;
        },
        async Reject(data) {
            const response = await axios.post(`/api/hroperations/employeelevy/reject`, data);
            return response;
        },
        async Confirm(id) {
            const response = await axios.post(`/api/hroperations/employeelevy/payment/confirm/${id}`);
            return response;
        },
        async ToggleActive(data) {
            const response = await axios.get(`/api/hroperations/employee/levy/toggleactive/${data}`);
            return response;
        },
        File: {
            async Table(data) {
                const response = await axios.post(`/api/hroperations/employeelevy/file/table`, data);
                return response;
            },
            async Upload(data) {
                const response = await axios.post(`/api/hroperations/employeelevy/file/upload`, data, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/hroperations/employeelevy/file/delete/${data}`);
                return response;
            },
        },
        Payment: {
            async Table(data, id) {
                const response = await axios.post(`/api/hroperations/employeelevypayment/table/${id}`, data);
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/hroperations/employeelevypayment/delete/${data}`);
                return response;
            },
            async CreateOrUpdate(update, data) {
                const response = await axios.post(update ? `/api/hroperations/employeelevypayment/update` : `/api/hroperations/employeelevypayment/create`, data);
                return response;
            },
        },
        async UploadExcel(data) {
            const response = await axios.post(`/api/hroperations/levy/uploadexcel`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
        async PaymentTable(data) {
            const response = await axios.post(`/api/hroperations/employee/levy/paymenttable/table`, data);
            return response;
        },
    },
    Advance: {
        async GetSetAssignment(data) {
            const response = await axios.post(`/api/hroperations/kykm/getassignments`, data);
            return response;
        },
    },
    HRAssignToBranch: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/hrassigntobranch/table`, data);
            return response;
        },
        async Assign(data) {
            const response = await axios.post(`/api/hroperations/hrassigntobranch/assign`, data);
            return response;
        },
        async EmployeeList() {
            const response = await axios.get(`/api/hroperations/hrassigntobranch/employee/list`);
            return response;
        },
        async Unassign(data) {
            const response = await axios.post(`/api/hroperations/hrassigntobranch/unassign/${data}`);
            return response;
        },
    },
    Crash: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/vehiclecrashinfo/table`, data);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/hroperations/vehiclecrashinfo/update` : `/api/hroperations/vehiclecrashinfo/create`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/vehiclecrashinfo/delete/${data}`);
            return response;
        },
        Payment: {
            // async Table(data,id){
            //     const response = await axios.post(`/api/hroperations/vehiclecrashinfopayment/table/${id}`,data)
            //     return response
            // },
            async Table(id) {
                const response = await axios.get(`/api/hroperations/vehiclecrashinfopayment/table/${id}`);
                return response;
            },
            async Delete(data) {
                const response = await axios.post(`/api/hroperations/vehiclecrashinfopayment/delete/${data}`);
                return response;
            },
            async Update(data) {
                const response = await axios.post(`/api/hroperations/vehiclecrashinfopayment/update`, data);
                return response;
            },
        },
    },
    Bes: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/bes/table`, data);
            return response;
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? `/api/hroperations/bes/update` : `/api/hroperations/bes/create`, data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/bes/delete/${data}`);
            return response;
        },
        async Upload(data) {
            const response = await axios.post(`/api/hroperations/bes/uploadexcel`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
        async GetSampleExcel() {
            const response = await axios.get(`/api/hroperations/employee/bes/downloadsample`, {
                responseType: "blob",
            });
            return response;
        },
    },
    Ticket: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employee/ticketpaymentconfig/paginate`, data);
            return response;
        },
        async CreateOrUpdate(editing, data) {
            const response = await axios.post(editing ? `/api/hroperations/employee/ticketpaymentconfig/update` : `/api/hroperations/employee/ticketpaymentconfig/create`, data);
            return response;
        },
        async Cancel(data) {
            const response = await axios.post(`/api/hroperations/employee/ticketpaymentconfig/disactive/${data}`);
            return response;
        },
    },
    async UploadPayroll(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/netsis/uploadpayroll`, data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response;
    },
    async UploadBonus(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/bonuspayment/uploadexcel`, data, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response;
    },
    async SalaryTable(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/table`, data);
        return response;
    },
    async SalaryTableExcel(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/table/excel`,data);
        return response;
    },
    async SalaryApprove(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/approve`, data);
        return response;
    },
    async SalaryDeleteApproved(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/deleteapproved`, data);
        return response;
    },
    async SalaryApprovedTable(data) {
        const response = await axios.post(`/api/hroperations/employee/salary/paginateapproved`, data);
        return response;
    },
    async SalaryScreenData() {
        const response = await axios.get(`/api/hroperations/employee/salary/getscreendata`);
        return response;
    },
    async BrutlestirmeKontrol() {
        const response = await axios.get(`/api/hroperations/salary/calculate/brutlestirmekontrol`);
        return response;
    },
    async PuantajHazirlikBilgiGirisiKontrol() {
        const response = await axios.get(`/api/hroperations/salary/calculate/puantajhazirlikbilgigirisikontrol`);
        return response;
    },
    async DonemKontrol() {
        const response = await axios.get(`/api/hroperations/salary/calculate/netsisdonemkontrol`);
        return response;
    },
    async GetBonusPaymentSampleExcel() {
        const response = await axios.get(`/api/hroperations/employee/salary/bonuspayment/downloadsample`, {
            responseType: "blob",
        });
        return response;
    },
    async PaymentTable(identity, month, year) {
        const response = await axios.get(`/api/hroperations/employee/payment/table/${identity}/${month}/${year}`);
        return response;
    },
    OccupationTitle: {
        async Create(data) {
            const response = await axios.post(`/api/hroperations/employee/occupationtitle/create`, data);
            return response;
        },
        async List(id) {
            const response = await axios.get(`/api/hroperations/employee/occupationtitle/list/${id}`);
            return response;
        },
    },
    async EmployeeExceptionalKYKMCalculate(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/calculate`, data);
        return response;
    },
    async EmployeeExceptionalKYKMIntervent(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/intervent`, data);
        return response;
    },
    async EmployeeExceptionalKYKMApprove(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/approve`, data);
        return response;
    },
    async EmployeeExceptionalKYKMCalculationStatusTable(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/calculationstatus/table`, data);
        return response;
    },
    async EmployeeExceptionalKYKMCalculationStatusEmployees(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/calculationstatus/getemployees`, data);
        return response;
    },
    async EmployeeExceptionalKYKMCalculationStatusSGKJobNotices(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/calculationstatus/sgkjobnotices`, data);
        return response;
    },
    async EmployeeExceptionalKYKMManualSet(data) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/manualset`, data);
        return response;
    },
    async EmployeeExceptionalKYKMManualDelete(id) {
        const response = await axios.post(`/api/hroperations/employee/kykm/exceptional/manualdelete/${id}`);
        return response;
    },
    async BESRobotP1() {
        const response = await axios.get(`/api/hroperations/bes/robotp1`);
        return response;
    },
    async BESRobotP2(code, month, year) {
        const response = await axios.get(`/api/hroperations/bes/robotp2/${code}/${month}/${year}`);
        return response;
    },
    async RegCodesByBranch(branchId, month, year) {
        const response = await axios.get(`/api/hroperations/salary/calculate/employeeregcodesbybranch/${branchId}/${month}/${year}`);
        return response;
    },
    async TopluBrutlestir(data) {
        const response = await axios.post(`https://netsisintegration.sertellojistik.com:444/api/nikopenx/toplubrutlestir`, data);
        return response;
    },
    async TekilBrutlestir(data) {
        const response = await axios.post(`https://netsisintegration.sertellojistik.com:444/api/nikopenx/tekilbrutlestir`, data);
        return response;
    },
    async BrutlestirmeGuncelKontrol(month, year) {
        const response = await axios.get(`/api/hroperations/salary/calculate/brutlestirmeguncelkontrol/${month}/${year}`);
        return response;
    },
    Form: {
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? `/api/hroperations/form/update` : `/api/hroperations/form/create`, data);
            return response;
        },
        async QuestionDelete(id) {
            const response = await axios.post(`/api/hroperations/form/question/delete/${id}`);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/hroperations/form/delete/${id}`);
            return response;
        },
        async QuestionCreate(data) {
            const response = await axios.post(`/api/hroperations/form/question/create`, data);
            return response;
        },
        async AnswerOptionCreate(data) {
            const response = await axios.post(`/api/hroperations/form/answeroption/create`, data);
            return response;
        },
        async AnswerTypeList() {
            const response = await axios.post(`/api/hroperations/form/answertype/list`);
            return response;
        },
        async AnswerByTypeId(typeId) {
            const response = await axios.post(`/api/hroperations/form/answer/${typeId}`);
            return response;
        },
        async Get(id) {
            const response = await axios.post(`/api/hroperations/form/get/${id}`);
            return response;
        },
        async GetFilled(id, eid) {
            const response = await axios.post(`/api/hroperations/form/getfilled/${id}/${eid}`);
            return response;
        },
        async Table(data) {
            const response = await axios.post(`/api/hroperations/form/table`, data);
            return response;
        },
        async FormApply(data) {
            const response = await axios.post(`/api/hroperations/form/apply`, data);
            return response;
        },
    },
    LucaCode: {
        async List() {
            const response = await axios.post(`/api/hroperations/employee/score/lucacodematch/list`);
            return response;
        },
        async Create(ewtId, code) {
            const response = await axios.post(`/api/hroperations/employee/score/lucacodematch/create/${ewtId}/${code}`);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/hroperations/employee/score/lucacodematch/delete/${id}`);
            return response;
        },
    },
    LucaBordro: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employee/score/luca/getbordro`, data);
            return response;
        },
        async Upload(data) {
            const response = await axios.post(`/api/hroperations/employee/score/luca/uploadbordro`, data, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        },
    },
    LucaResult: {
        async Calculate(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/calculateresultsforluca`, data);
            return response;
        },
        async GetCalculated(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/getcalculatedresultsforluca`, data);
            return response;
        },
        async Approve(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/confirm`, data);
            return response;
        },
        async Confirm(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/confirm`, data);
            return response;
        },
        async Lock(data) {
            const response = await axios.post(`/api/hroperations/employee/rsalary/togglelock`, data);
            return response;
        },
        async ConfirmedTable(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/confirmed/table`, data);
            return response;
        },
        async ConfirmG(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/confirmg`, data);
            return response;
        },
        async LockG(data) {
            const response = await axios.post(`/api/hroperations/employee/gsalary/togglelock`, data);
            return response;
        },
    },
    FM: {
        async EmployeeInfo(employeeid, date) {
            const response = await axios.get(`/api/hroperations/fm/employeeinfo/${employeeid}/${date}`);
            return response;
        },
    },
    GSalary: {
        async Excel(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/getemptygtable`, data);
            return response;
        },
        async TicketExcel(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/getgtickettable`, data);
            return response;
        },
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/getgtable`, data);
            return response;
        },
        async Update(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/updategtable`, data);
            return response;
        },
        async UploadGTable(data) {
            const response = await axios.post("/api/hroperations/employee/salary/uploadgtable", data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        async ManAllowanceTable(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/getmanallowancetable`, data);
            return response;
        },
        async UploadManAllowance(data) {
            const response = await axios.post("/api/hroperations/employee/salary/uploadmanallowance", data, { headers: { "Content-Type": "multipart/form-data" } });
            return response;
        },
        async EkHakedisReport(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/ekhakedisreport`, data);
            return response;
        },
        async MaasBilgileriReport(data) {
            const response = await axios.post(`/api/hroperations/employee/salary/maasbilgilerireport`, data);
            return response;
        },
        async ConfirmationStep(data) {
            const response = await axios.post(`/api/hroperations/employee/gsalary/confirmationstep/table`, data);
            return response;
        },
        async PayrollUploadTable(data) {
            const response = await axios.post(`/api/hroperations/employee/gsalary/fileupload/table`, data);
            return response;
        },
        async KasaDekont(employeeSalaryGroupId, month, year) {
            const response = await axios.post(`/api/hroperations/employee/gsalary/kasadekont/${employeeSalaryGroupId}/${month}/${year}`);
            return response;
        },
        async UploadPayroll(data) {
            const response = await axios.post(`/api/hroperations/employee/gsalary/uploadpayroll`, data);
            return response;
        },
    },
    DepartmentTitle: {
        async Table(data, employeeId) {
            const response = await axios.post(`/api/hroperations/employee/departmenttitle/table/${employeeId}`, data);
            return response;
        },
    },
    Operation: {
        async Transfer(data) {
            const response = await axios.post(`/api/hroperations/employee/operation/transfer`, data);
            return response;
        },
        async UpdateGarage(data) {
            const response = await axios.post(`/api/hroperations/employee/garage/update`, data);
            return response;
        },
        async DeleteGarage(id) {
            const response = await axios.post(`/api/hroperations/employee/garage/delete/${id}`);
            return response;
        },
        async UpdateTitle(data) {
            const response = await axios.post(`/api/hroperations/employee/title/update`, data);
            return response;
        },
        async DeleteTitle(id) {
            const response = await axios.post(`/api/hroperations/employee/edt/delete/${id}`);
            return response;
        },
        async UpdateBranchSession(data) {
            const response = await axios.post(`/api/hroperations/employee/branchsession/update`, data);
            return response;
        },
        async DeleteBranchSession(id) {
            const response = await axios.post(`/api/hroperations/employee/branchsession/delete/${id}`);
            return response;
        },
    },
    Report: {
        async EmployeeBasic(data) {
            const response = await axios.post(`/api/hroperations/report/employeebasic`, data);
            return response;
        },
        async PersonnelReport(data) {
            const response = await axios.post(`/api/hroperations/report/personnelreport`, data);
            return response;
        },
        async EmployeeExpense(data) {
            const response = await axios.post(`/api/hroperations/report/employeeexpense`, data);
            return response;
        },
        async EmployeeExpenseMonthly(data) {
            const response = await axios.post(`/api/hroperations/report/employeeexpensemonthly`, data);
            return response;
        },
    },
    async SearchByCollarStatusAndIdentity(data) {
        const response = await axios.post(`/api/hroperations/employee/searchbycollarstatusandidentity`, data);
        return response;
    },
    async GetGSalaryListPaymentOrder(month, year) {
        const response = await axios.post(`/api/hroperations/employee/gsalary/paymentorder/${month}/${year}`);
        return response;
    },
    async RSalaryLockedListByBranch(data) {
        const response = await axios.post(`/api/hroperations/rsalary/locked/listbybranch`, data);
        return response;
    },
    async GSalaryLockedListByBranch(data) {
        const response = await axios.post(`/api/hroperations/gsalary/locked/listbybranch`, data);
        return response;
    },
    SalaryGroup: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/employeesalarygroup/table`, data);
            return response;
        },
        async List() {
            const response = await axios.post(`/api/hroperations/employeesalarygroup/list`);
            return response;
        },
        async CreateOrUpdate(update, data) {
            const response = await axios.post(update ? "/api/hroperations/employeesalarygroup/update" : "/api/hroperations/employeesalarygroup/create", data);
            return response;
        },
        async Delete(data) {
            const response = await axios.post(`/api/hroperations/employeesalarygroup/delete/${data}`);
            return response;
        },
    },
    async jobExitTask(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/exittask", data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    },
    async jobExitTaskAbort(id) {
        const response = await axios.get(`/api/hroperations/employee/sgk/exittask/abort/${id}`);
        return response;
    },
    async exitTaskInfo(employeeId) {
        const response = await axios.get(`/api/hroperations/employee/sgk/exittaskinfo/${employeeId}`);
        return response;
    },
    async exitTaskCheckScore(taskId) {
        const response = await axios.get(`/api/hroperations/employee/sgk/exittask/checkscore/${taskId}`);
        return response;
    },
    async jobExitUploadBordros(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/exit/uploadbordros", data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    },
    async ArabuluculukHakedisTablosuExcel(taskId) {
        const response = await axios.post(`/api/hroperations/employee/sgk/exit/arabuluculukhakedistablosuexcel/${taskId}`);
        return response;
    },
    async UploadHakedisTablosu(taskId, data) {
        const response = await axios.post(`/api/hroperations/employee/sgk/exit/uploadhakedistablosu/${taskId}`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    },
    async ArabuluculukInfo(taskId) {
        const response = await axios.get(`/api/hroperations/employee/arabuluculukinfo/${taskId}`);
        return response;
    },
    async CompleteExit(taskId) {
        const response = await axios.get(`/api/hroperations/employee/sgk/completeexit/${taskId}`);
        return response;
    },
    async UpdateApproverOfExitTask(taskId, approver) {
        const response = await axios.post(`/api/hroperations/employee/sgk/updateapproverofexittask/${taskId}/${approver}`);
        return response;
    },
    async DeleteApproverOfExitTask(taskId) {
        const response = await axios.post(`/api/hroperations/employee/sgk/updateapproverofexittask/${taskId}`);
        return response;
    },
    async UpdateHerSeyDahilOfExitTask(taskId, herSeyDahil) {
        const response = await axios.post(`/api/hroperations/employee/sgk/updateherseydahilofexittask/${taskId}/${herSeyDahil}`);
        return response;
    },
    async ListMediationPayments(taskId) {
        const response = await axios.get(`/api/hroperations/employee/arabuluculuk/payments/${taskId}`);
        return response;
    },
    async AddMediationPayment(data) {
        const response = await axios.post(`/api/hroperations/employee/arabuluculuk/payments`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    },
    async DeleteMediationPayment(paymentId) {
        const response = await axios.post(`/api/hroperations/employee/arabuluculuk/payments/delete/${paymentId}`);
        return response;
    },
    async ExitFiles(taskId) {
        const response = await axios.post(`/api/hroperations/employee/sgk/exit/document/${taskId}`);
        return response;
    },
    async ExitGenerateFile(data) {
        const response = await axios.post(`/api/hroperations/employee/sgk/exit/document/generate`, data);
        return response;
    },
    async ExitUploadSignedFile(taskId, documentId, formData) {
        const response = await axios.post(`/api/hroperations/employee/sgk/exit/document/uploadsigned/${taskId}/${documentId}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    },
    GarageSalaryMulti: {
        async Table(data) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/salaryassignment/table`, data);
            return response;
        },
        async Assign(data) {
            const response = await axios.post("/api/hroperations/vehicleinventorygarage/salaryassignment/assign", data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/hroperations/vehicleinventorygarage/salaryassignment/delete/${id}`);
            return response;
        },
    },
    TikcetNew: {
        async ToggleActiveStatus(id) {
            const response = await axios.post(`/api/hroperations/employee/ticketcard/toggleactivestatus/${id}`);
            return response;
        },
        async Create(data) {
            const response = await axios.post(`/api/hroperations/employee/ticketcard/create`, data);
            return response;
        },
        async Delete(id) {
            const response = await axios.post(`/api/hroperations/employee/ticketcard/delete/${id}`);
            return response;
        },
        async List(eid) {
            const response = await axios.post(`/api/hroperations/employee/ticketcard/list/${eid}`);
            return response;
        },
    },
    async DriverLicenseDashboard() {
        const response = await axios.get(`/api/hroperations/employee/digitaldriverlicense/dashboard`);
        return response;
    },
    async MediationReport(data) {
        const response = await axios.post(`/api/hroperations/mediation/report`, data);
        return response;
    },
    async GetOver65Years() {
        const response = await axios.get(`/api/hroperations/employee/over65years`);
        return response;
    },
    async GSalaryFileUploadReportTable(data) {
        const response = await axios.post("/api/hroperations/employee/gsalary/fileupload/report/table", data);
        return response;
    },
    async RegistryDocumentReport(data) {
        const response = await axios.post("/api/hroperations/registrydocument/report", data);
        return response;
    },
    async GetSicilDosyalariReport(data) {
        const response = await axios.post("/api/hroperations/sicildosyalari/report", data);
        return response;
    },
    async GetExitDocumentsReport(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/exit/document/report", data);
        return response;
    },
    // --- Madde 19: Eski çıkış kayıtlarını düzenleme/tamamlama ekranı ---
    async OldExitList(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/oldexit/list", data);
        return response;
    },
    async OldExitSave(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/oldexit/save", data);
        return response;
    },
    async OldExitBulkAssign(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/oldexit/bulkassign", data);
        return response;
    },
    // Ana ekran arabuluculuk dashboard özeti (salt-okuma).
    async MediationDashboard() {
        const response = await axios.get("/api/hroperations/employee/sgk/mediation/dashboard");
        return response;
    },
    // Arabuluculuk ana ekranı: çıkışı tamamlanmış personeller listesi.
    async MediationCompletedExits(data) {
        const response = await axios.post("/api/hroperations/employee/sgk/mediation/completedexits", data);
        return response;
    },
    async SendGSMVerification(data) {
        const response = await axios.post(`/api/hroperations/employee/sendgsmverification/${data}`);
        return response;
    },
    async VerifyGSM(data, code) {
        const response = await axios.post(`/api/hroperations/employee/verifygsm/${data}/${code}`);
        return response;
    },
};
